import { types, getSnapshot, applySnapshot } from 'mobx-state-tree';
import generateUUID from 'uuid/v1';
import { castEventToValue } from 'js/services/FormTools';
import { blueColor } from 'js/config/style';

export default types
  .model('BankAccount', {
    uuid: types.optional(types.string, generateUUID),
    id: 0,
    account: '',
    route: '',
    bank_code: '',
    number: '',
    type: 'Checking',
    is_verified: types.optional(types.maybeNull(types.boolean), false),
    onboarding_service: 'internal',
    can_submit_verification: false,
    verification_wait_reason: '',
    verification_denial_reason: '',
    verification_failure_message: '',
    account_name: '',
    institution_name: '',
    institution_logo: '',
    institution_primary_color: '',
    institution_url: '',
    has_failed: false,
    needs_update: false,
    report_update_errors: types.optional(types.array(types.string), []),
    bank_verification_flow: 'system',
  })
  .views(self => ({
    get isNew() {
      return !self.id;
    },
    get isFilledIn() {
      return !!((self.route && self.number) || (self.number && self.bank_code) || self.id);
    },
    get logo_src() {
      return self.institution_logo ? `data:image/jpeg;base64,${self.institution_logo}` : null;
    },
    get institution_color() {
      return self.institution_primary_color || blueColor;
    },
  }))
  .actions(self => ({
    setId(id) {
      self.id = id;
      return self;
    },
    setRoute(route) {
      self.route = castEventToValue(route);
      return self;
    },
    setBankCode(bank_code) {
      self.bank_code = castEventToValue(bank_code);
      return self;
    },
    setNumber(number) {
      self.number = castEventToValue(number);
      return self;
    },
    setType(type) {
      self.type = castEventToValue(type);
      return self;
    },
    setBankAccount(snapshot) {
      applySnapshot(self, snapshot ? { ...getSnapshot(self), ...snapshot } : {});
      return self;
    },
  }));
